import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '../../../services/local-storage.service';
import { environment } from '../../../../../environments/environment';
import { OpenId } from '../libs/openid';
import { ByPass } from '../libs/bypass';
import { Oauth2 } from '../libs/oauth2';
import { CryptoService } from '../../../services/crypto.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { SessionStorageService } from '../../../services/session-storage.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public driver: any;

  constructor(private http: HttpClient, private localStorage: LocalStorageService, private sessionStorage: SessionStorageService,
              private cryptoService: CryptoService, private modalService: NgbModal, private router: Router, private toastr: ToastrService) {
    switch (environment.auth.type) {
      case 'openid':
        this.driver = new OpenId();
        break;
      case 'oauth2':
        this.driver = new Oauth2(this.http, this.localStorage, this.cryptoService);
        break;
      default:
        this.driver = new ByPass(this.localStorage);
    }
  }

  public login(data) {
    return this.driver.login(data);
  }

  public logout() {
    return this.driver.logout();
  }

  public isAuthenticated() {
    return this.driver.isAuthenticated();
  }

  public getUserInfo() {
    return this.driver.getUserInfo();
  }

  public getToken() {
    return this.driver.getToken();
  }

  public getUsername() {
    return this.driver.getUsername();
  }

  public getAuthParams() {
    return this.driver.getAuthParams ? this.driver.getAuthParams() : '';
  }

  public tryToUseRefreshToken() {
    if (this.driver.doUseRefreshToken) {
      return this.driver.doUseRefreshToken();
    } else {
      return throwError('Redirect to login page');
    }
  }
}
